window.addToCart = (data, callback = false) => {
  fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      console.log(response.json());

      if (!callback) {
        return;
      }

      callback();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

const addOnsWidgetID = '161676';

document.addEventListener('rebuy.ready', (event) => {
  if (event.detail.widget.id !== addOnsWidgetID) {
    return;
  }

  window.addToCartAddOns = () => {
    const products = event.detail.widget.data.products;
    const selectedProducts = products.filter((product) => product.selected);

    const data = {
      items: [],
    };

    selectedProducts.forEach((product) => {
      const item = {
        quantity: product.quantity,
        id: product.selected_variant_id,
      };

      data.items.push(item);
    });

    window.addToCart(data);

    window.console.log('selectedProducts', selectedProducts);
  };
});
